module.exports = __webpack_public_path__ + "img/assign_tick.09a681d8.svg";